module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/schedule_05-81df5b285b22f2402bf9115e7bb0bc9b.jpg";